import { heroEquipment } from "../HeroEquipment";

export const moulder = {
  heroes: {
    "Mistrz mutator": {
      id: 0,
      startingEquipment: ["Sztylet", "Bicz"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Poganiacze klanu Moulder"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 2, 5, 1, 7],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Ciałokształtowanie",
        "Dowódca",
        "Ranger",
        "Rozproszenie magii (2)",
        "Strachliwy",
        "W nogi!",
      ],
      exp: 20,
      skills: [0, 2, 4, 5],
    },
    "Mistrz ciałokształtowania": {
      id: 1,
      startingEquipment: ["Sztylet", "Bicz"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Poganiacze klanu Moulder"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 3, 3, 3, 3, 1, 4, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Ciałokształtowanie",
        "Ranger",
        "Rozproszenie magii (1)",
        "W nogi!",
      ],
      exp: 8,
      skills: [0, 2, 4, 5],
    },
    Poganiacz: {
      id: 2,
      startingEquipment: ["Sztylet", "Bicz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Poganiacze klanu Moulder"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 3, 3, 3, 3, 1, 5, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Ranger", "Treser", "W nogi!"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    "Łowca niewolników": {
      id: 3,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Poganiacze klanu Moulder"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 3, 3, 3, 3, 1, 5, 1, 5],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Handlarz niewolników", "Ranger", "W nogi!", "Zabójca potworów"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    Klanbrat: {
      id: 5,
      startingEquipment: ["Sztylet", "Włócznia"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Poganiacze klanu Moulder"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 3, 3, 3, 3, 1, 4, 1, 5],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Ranger",
        "W nogi!",
      ],
    },
    "Wielki szczur": {
      id: 6,
      startingEquipment: ["Broń naturalna"],
      cost: 15,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 2, 0, 3, 3, 1, 4, 1, 3],
        Maksymalna: [6, 2, 0, 3, 3, 1, 4, 1, 3],
      },
      rules: ["Murołaz", "Sfora", "W nogi!", "Wodny", "Zwierzę"],
    },
    Szczurogr: {
      id: 7,
      startingEquipment: ["Broń naturalna"],
      cost: 160,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 1, 5, 4, 3, 4, 2, 5],
        Maksymalna: [6, 6, 1, 5, 5, 5, 6, 5, 7],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Konstrukt",
        "Murołaz",
        "Ograniczony",
        "Przepastne trzewia",
        "Stan niższy",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
    },
    Więźniarka: {
      id: 8,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Wilkoszczur: [9, 3, 0, 3, "-", "-", 4, 1, 3],
        "Wilkoszczur ": [9, 3, 0, 3, "-", "-", 4, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
    Ambulatorium: {
      id: 9,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Wilkoszczur: [9, 3, 0, 3, "-", "-", 4, 1, 3],
        "Wilkoszczur ": [9, 3, 0, 3, "-", "-", 4, 1, 3],
      },
      rules: [
        "Chirurgia",
        "Duży cel",
        "Machina wojenna",
        "Powóz",
        "Szpital polowy",
      ],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Poganiacze klanu Moulder",
  nature: "Chaotyczna",
  armyRules: ["Rozrzutność"],
  mercenaries: ["Szczurogr", "Szpieg", "Złodziej"],
};
